import { render, staticRenderFns } from "./FDayaDukungTable.vue?vue&type=template&id=899af64e&scoped=true"
import script from "./FDayaDukungTable.vue?vue&type=script&lang=js"
export * from "./FDayaDukungTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899af64e",
  null
  
)

export default component.exports